import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
export const CheckboxField = ({
  name,
  fieldId,
  labelName = "",
  onChange,
  checked,
  errorMessage,
  valid = "",
  disabled,
  align = "end",
  size = "small",
  sx,
  color = "primary",
}: IText) => {
  return (
    <FormControlLabel
      labelPlacement={align}
      id={fieldId}
      sx={sx}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          size={size}
          name={name}
          color={color}
        />
      }
      label={labelName}
    />
  );
};

export interface IText {
  name: string;
  fieldId: string;
  onChange: any;
  checked: boolean;
  errorMessage?: string;
  labelName?: any;
  valid?: any;
  disabled?: boolean;
  align?: "end" | "start" | "top" | "bottom";
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  size?: "small" | "medium";
  sx?: any;
}
